import script from "./ResearchProjectForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ResearchProjectForm.vue?vue&type=script&setup=true&lang=js"

import "./ResearchProjectForm.vue?vue&type=style&index=0&id=6ce6d300&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ce6d300"]])

export default __exports__